import { get } from './http';

export const getZipFile = async (categories, channelId, downloadImages) => {
  const categoriesAsQuery = categories
    .reduce((acc, curr) => {
      acc.push(`categoryIds=${curr}`);
      return acc;
    }, [])
    .join('&');
  const response = await get(
    `/api/marketingmaterial/download?${categoriesAsQuery}&channelId=${channelId}&downloadImages=${downloadImages}`,
    { responseType: 'arraybuffer' }
  );
  const res = await response.arrayBuffer();
  const blob = new Blob([res], { type: 'octet/stream' });
  const date = new Date();
  const fileName = 'marketingmaterial.zip';
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display:none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
};
